<template>
  <v-row class="d-flex justify-center">
    <v-col cols="12" class="text-center mt-n8 mb-0 mb-md-6">
      <div class="title-font-secondary" v-html="t('title')"></div>
      <div class="mt-4">{{ t("description") }}</div>
    </v-col>
    <v-col
      class="d-flex flex-row align-center justify-center mt-8"
      cols="3"
      sm="2"
      md="3"
      v-for="(item, i) of items"
      :key="i"
    >
      <v-img height="auto" :max-width="$root.isDesktop ?  '190px' : '100%'" :src="item.icon"></v-img>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data: (vm) => ({
    items: vm.colaborators([
      "selina",
      "viva",
      "aloft",
      "alux",
      "tony",
      "viajesmillenial",
      "ayenda",
      "guru",
      "yinyang",
    ]),
  }),
  methods: {
    t(key, options = {}) {
      return this.$t(`public.landing.colaborator.${key}`, options);
    },
    colaborators: (colaborators) =>
      colaborators.map((colaborator) => ({
        icon: require(`@/assets/images/logo-${colaborator}.png`),
      })),
  },
};
</script>
